import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

/**
 * MIconFieldComponent wraps an input and a Material icon (using a <span> with Material Icons classes),
 * allowing the icon to be placed left or right of the input.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-icon-field',
  imports: [NgClass],
  templateUrl: './m-icon-field.component.html',
  styleUrls: ['./m-icon-field.component.scss']
})
export class MIconFieldComponent {
  /** The Material icon name to display (e.g., 'calendar_today', 'tune') */
  @Input() icon!: string;
  /** Position of the icon: 'left' or 'right' (default: 'right') */
  @Input() iconPosition: 'left' | 'right' = 'right';

  @Input() disabled = false;
}
